import React from "react";
import SmartIcon from "../SmartIcon.tsx";
import {DrawerHeader} from "@chakra-ui/react";
import useUiStore from "../../store/useUiStore.ts";

interface ProjectDrawerHeaderProps {
  projectId: string;
}

const ProjectDrawerHeader: React.FC<ProjectDrawerHeaderProps> = ({projectId}: ProjectDrawerHeaderProps) => {
  const {showToast} = useUiStore()

  return (
    <DrawerHeader fontSize="3xl" fontWeight="bold" className="flex items-center gap-4 text-n-200">
      Project details
      <div
        className="hover:scale-125"
        onClick={() => {
          navigator.clipboard.writeText(projectId).catch(e => console.error("Failed to copy project ID:", e));
          showToast("Project ID was copied to clipboard", "success");
        }}
      >
        <SmartIcon name={"copy"} fill="#fff" className={"w-4 h-4 cursor-pointer"}/>
      </div>
    </DrawerHeader>
  )
}

export default ProjectDrawerHeader;